export class Faq {
    constructor() {
        this.eventHandlers();
    }
    eventHandlers() {
        $(document).on('click', 'section.faq .faq-elem .top', this.toggleFaq.bind(this));
    }
    toggleFaq(e) {
        const _this = $(e.currentTarget);
        let is_open = _this.parents('.faq-elem').hasClass('open');
        if (is_open) {
            _this.parents('.faq-elem').removeClass('open');
        } else {
            _this.parents('.faq-elem').addClass('open');
        }
        _this.parents('.faq-elem').find('.content').slideToggle();
    }
}